import React from 'react'

export default function Ruble() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M7.9998 15.1998C11.9763 15.1998 15.1998 11.9763 15.1998 7.9998C15.1998 4.02335 11.9763 0.799805 7.9998 0.799805C4.02335 0.799805 0.799805 4.02335 0.799805 7.9998C0.799805 11.9763 4.02335 15.1998 7.9998 15.1998Z"
                stroke="#2F3237"
                strokeWidth="1.08"
            />
            <path
                d="M5.83984 9.4399H7.99984M6.55984 7.9999V5.2639C6.55984 5.12998 6.55984 5.06302 6.56848 5.00758C6.5922 4.85723 6.66295 4.71826 6.77058 4.61063C6.8782 4.50301 7.01717 4.43226 7.16752 4.40854C7.22224 4.3999 7.28992 4.3999 7.42384 4.3999H9.07984C9.55723 4.3999 10.0151 4.58954 10.3526 4.92711C10.6902 5.26468 10.8798 5.72251 10.8798 6.1999C10.8798 6.67729 10.6902 7.13513 10.3526 7.47269C10.0151 7.81026 9.55723 7.9999 9.07984 7.9999H6.55984ZM6.55984 7.9999V11.5999M6.55984 7.9999H5.83984"
                stroke="#2F3237"
                strokeWidth="1.08"
                strokeLinecap="round"
            />
        </svg>
    )
}
